module.exports = __webpack_public_path__ + "img/55.80360d5a.jpg";